export function formatAmountType(value: string, type: string) {
    const numericValue = value.replace(/[^0-9.]/g, '');
    const formattedValue = (type === 'percent' ? Math.min(parseFloat(numericValue), 100) + '%' : '$' + parseFloat(numericValue).toFixed(2));
    return formattedValue;
}
